<template>
  <v-list-item
    v-if="hasPermission || isEmployment || isManager"
    :href="href"
    :rel="href && href !== '#' ? 'noopener' : undefined"
    :target="href && href !== '#' ? '_blank' : undefined"
    :to="item.to"
    :active-class="``"
  >
    <v-list-item-icon v-if="item.icon">
      <v-icon v-text="item.icon" />
    </v-list-item-icon>

    <v-list-item-content v-if="item.title">
      <v-list-item-title v-text="item.title" class="text-h3 white--text" />
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";

export default {
  name: "BaseItem",

  mixins: [Themeable],

  props: {
    item: {
      type: Object,
      default: () => ({
        href: undefined,
        icon: undefined,
        title: undefined,
        to: undefined,
        groups: undefined,
      }),
    },
    text: {
      type: Boolean,
      default: false,
    },
    // currentUser: Object,
  },
  methods: {
    // hasPermission(item) {
    //   if (
    //     this.$store.getters.getCurrentUser &&
    //     this.$store.getters.getCurrentUser.isStaff
    //   ) {
    //     return true;
    //   }
    //   if (
    //     !this.$store.getters.getCurrentUser ||
    //     !this.$store.getters.getCurrentUser.isStaff
    //   ) {
    //     let hasPermission = false;
    //     if (this.$store.state.currentUser) {
    //       let currentUserGroups = this.$store.getters.getCurrentUser.groups;
    //       for (let i = 0; i < item.groups.length && !hasPermission; i++) {
    //         for (
    //           let j = 0;
    //           j < currentUserGroups.length && !hasPermission;
    //           j++
    //         ) {
    //           if (item.groups[i] === currentUserGroups[j].name)
    //             hasPermission = true;
    //         }
    //       }
    //       return hasPermission;
    //     }
    //   }
    //   return false;
    // },
    // isEmployment(item) {
    //   // console.log(item);
    //   if (item.groups && item.groups.includes("all")) {
    //     return true;
    //   }
    //   let currentUser = this.$store.getters.getCurrentUser;
    //   if (currentUser) {
    //     if (currentUser.employment !== null) {
    //       let hasPermission = false;
    //       for (let i = 0; i < item.groups.length && !hasPermission; i++) {
    //         if (item.groups[i] === "isEmployment") hasPermission = true;
    //       }
    //       return hasPermission;
    //     }
    //   }
    //   return false;
    // },
    // isManager(item) {
    //   if (item.groups && item.groups.includes("all")) {
    //     return true;
    //   }
    //   let currentUser = this.$store.getters.getCurrentUser;
    //   if (currentUser) {
    //     if (currentUser.manager !== null) {
    //       let hasPermission = false;
    //       for (let i = 0; i < item.groups.length && !hasPermission; i++) {
    //         if (item.groups[i] === "isManager") hasPermission = true;
    //       }
    //       return hasPermission;
    //     }
    //   }
    //   return false;
    // },
  },
  computed: {
    hasPermission() {
      const currentUser = this.$store.getters.getCurrentUser;
      if (currentUser && currentUser.isStaff) {
        return true;
      }

      if (!currentUser || !currentUser.isStaff) {
        if (currentUser) {
          const currentUserGroups = currentUser.groups;
          return this.item.groups?.some((group) =>
            currentUserGroups?.some((userGroup) => userGroup.name === group)
          );
        }
      }

      return false;
    },
    isEmployment() {
      return this.item.groups && this.item.groups.includes("all")
        ? true
        : this.$store.getters.getCurrentUser &&
            this.$store.getters.getCurrentUser.employment !== null &&
            this.item.groups.includes("isEmployment");
    },
    isManager() {
      return this.item.groups && this.item.groups.includes("all")
        ? true
        : this.$store.getters.getCurrentUser &&
            this.$store.getters.getCurrentUser.manager !== null &&
            this.item.groups.includes("isManager");
    },

    href() {
      return this.item.href || (!this.item.to ? "#" : undefined);
    },
  },
};
</script>
